import { Loader2, Send } from "lucide-react";

// Armed is the second click: the label and the amber fill are what stop a double-click
// from creating a second John Deere file before the warning can be read.
export function JdSendButton(props: {
  sending: boolean;
  armed: boolean;
  disabled: boolean;
  title?: string;
  onSend: () => void;
}) {
  const { sending, armed, disabled, title, onSend } = props;
  return (
    <button
      onClick={onSend}
      disabled={disabled}
      className={`flex items-center justify-center gap-1.5 rounded px-3 py-1.5 text-[12px] font-medium disabled:opacity-40 ${armed ? "bg-amber-500 text-canvas hover:bg-amber-400" : "border border-line text-fg hover:bg-hover"}`}
      title={title}
    >
      {sending ? (
        <Loader2 size={13} className="animate-spin" />
      ) : (
        <Send size={13} />
      )}
      {armed ? "Send anyway — makes a new file" : "Send to JD Ops"}
    </button>
  );
}
